import { useEffect, useState } from "react";
import { getStreamingTrends } from '@/pages/opinion/services/community';
import { dealwithRatio, sortChannel } from "@op/pages/community/utils";
import { handleMentionData } from "@op/utils";
import { getNeedTime, getQOQText } from "@op/utils/time";
import { countMap, getDefaultChannelList } from "@op/pages/community/constants";
import { addStudioChannel } from "../../StudioTrendingVideo/utils";

const useStreamingTrendsData = (props: any) => {
  const { gameInfo, params, metric } = props || {};
  const [total, setTotal] = useState(0);
  const [lineSeriesData, setLineSeriesData] = useState<Array<any>>([]);
  const [lineXAxisData, setLineXAxisData] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(true);

  const clearRecords = () => {
    setTotal(0);
    setLineXAxisData([]);
    setLineSeriesData([]);
  };

  useEffect(() => {
    if (Object.keys(params).length === 0) {
      return;
    }
    setLoading(true);
    getStreamingTrends({ ...params, metric, source: 'stream', channels: addStudioChannel(params?.channels) })
      .then((data: any) => {
        const dateType = params.date_type || 'daily';
        const { timeline_of_end_time, timeline_of_start_time, list } = data || {};
        if (!list || list?.length === 0) {
          clearRecords();
        } else {
          // eslint-disable-next-line prefer-const
          let { charts, total } = dealwithRatio(
            timeline_of_start_time,
            timeline_of_end_time,
            list?.map((item: any) => ({
              time: item.time,
              name: item.key,
              count: item.value,
            })) || [],
            dateType,
            countMap[metric],
            params.channels,
          );
          const needTime = getNeedTime(dateType);

          const { newArr, timeArr } = handleMentionData(charts, needTime);

          const { isSingleDate } = getQOQText(
            dateType,
            params.start_time,
            params.end_time,
          );

          const defaultChannel = getDefaultChannelList(
            params.edition_unified_id,
          );

          // 兼容舆情接口修改（之前接口没有total需要前端计算，后端返回total使用后端的）
          // eslint-disable-next-line no-prototype-builtins
          const reqTotal = data?.hasOwnProperty('total'); // 请求返回total
          // 单天，单月，单周数据单独计算total
          if (isSingleDate && !reqTotal) {
            total = newArr.reduce((pre, cur) => {
              const len = cur.data.length - 1;
              return pre + cur.data[len];
            }, 0);
            if (metric === 'avgCCV') {
              total = total / (params.channels.length || defaultChannel.length);
            }
          } else {
            total = reqTotal ? data?.total : 0;
          }

          setTotal(total);
          setLineXAxisData(timeArr);
          sortChannel(newArr, (fun) => (a, b) => fun(a.name, b.name));
          setLineSeriesData(newArr);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [gameInfo, params, metric]);

  return {
    loading,
    total,
    lineSeriesData,
    lineXAxisData,
  };
};

export default useStreamingTrendsData;